import {Component, ViewChild, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

export interface PeriodicElement {
  patientID: string;
  weight: number;
  riskScore: number;
  BMI: number;
  age: number;
  gender: string;
  ethnicity: string;
  active: string;
  diagnosedpd: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {patientID: 'yRU2e50d5u', age: 43 , gender: 'Female' , ethnicity: 'Caucasia' , weight: 255, riskScore: 7, BMI: 40 , diagnosedpd: 'Yes', active: 'No'},
  {patientID: 'hxaEqIEgiK', age: 53 , gender: 'Female' , ethnicity: 'Asian' , weight: 278, riskScore: 4, BMI: 26 , diagnosedpd: 'No', active: 'Yes'},
  {patientID: 'GNPMrnyhxJ', age: 45 , gender: 'Male' , ethnicity: 'African American' , weight: 198, riskScore: 8, BMI: 56 , diagnosedpd: 'Yes', active: 'Yes'},
  {patientID: 'GoKroZhUJl', age: 44 , gender: 'Male' , ethnicity: 'African American' , weight: 243, riskScore: 10, BMI: 36 , diagnosedpd: 'Yes', active: 'No'},
  {patientID: 'VJtwT2wGUT', age: 67 , gender: 'Female' , ethnicity: 'Caucasia' , weight: 305, riskScore: 6, BMI: 21 , diagnosedpd: 'No', active: 'Yes'},
];

@Component({
  selector: 'app-docsummary',
  templateUrl: './docsummary.component.html',
  styleUrls: ['./docsummary.component.css']
})
export class DocsummaryComponent implements OnInit {
  [x: string]: any;
  displayedColumns: string[] = ['patientID', 'age' , 'gender', 'ethnicity' , 'weight' , 'riskScore', 'BMI' , 'diagnosedpd' , 'active' ];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  constructor( 
    private cookie: CookieService,
    private router : Router,
    ) {
   }

  @ViewChild(MatSort, {}) sort: MatSort;

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  
  cellClicked(element) {
    console.log(element.patientID + ' cell clicked');
    this.cookie.set("patientId", element.patientID);
    this.router.navigateByUrl('/docactivitytrend');
  }


  ngOnInit() {
    this.dataSource.sort = this.sort;
    
  }
}